/**
 * Tâche 1282 (Eric 2026-06-29) — Le courriel hebdomadaire des écarts.
 *
 * Personne ne reçoit rien sans l'avoir demandé (choix d'Eric) : l'envoi du
 * lundi matin est conditionné à cette case, stockée dans les préférences du
 * compte, donc valable sur tous les appareils.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API_BASE as API } from "../../lib/apiBase";
import { useLang } from "../../contexts/LanguageContext";

export const GapsWeeklyEmailToggle = () => {
  const { tr } = useLang();
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/auth/me/preferences`, { withCredentials: true });
        setEnabled(!!(data?.preferences || {}).email_gaps_weekly);
      } catch { /* silencieux : la case reste décochée */ }
    })();
  }, []);

  const toggle = async () => {
    const next = !enabled;
    setBusy(true);
    setEnabled(next);
    try {
      await axios.patch(
        `${API}/api/auth/me/preferences`,
        { email_gaps_weekly: next },
        { withCredentials: true },
      );
      toast.success(next
        ? tr("Tu recevras le palmarès des cinq écarts chaque lundi matin.", "You will get the top five gaps every Monday morning.")
        : tr("Courriel hebdomadaire des écarts désactivé.", "Weekly gaps email turned off."));
    } catch (e) {
      setEnabled(!next);
      toast.error(e.response?.data?.detail || tr("Préférence non enregistrée", "Preference not saved"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <label
      className="flex items-start gap-3 rounded-lg border border-zinc-200 bg-white p-4 cursor-pointer hover:border-zinc-300"
      data-testid="gaps-weekly-email-toggle"
    >
      <input
        type="checkbox"
        checked={enabled}
        onChange={toggle}
        disabled={busy}
        className="mt-0.5 h-4 w-4 accent-[#002FA7]"
        data-testid="gaps-weekly-email-checkbox"
      />
      <span>
        <span className="block text-sm font-medium text-zinc-900">
          {tr(
            "Recevoir le palmarès des cinq vidéos les plus trouées, chaque lundi",
            "Get the five most incomplete videos every Monday",
          )}
        </span>
        <span className="block text-xs text-zinc-500">
          {tr(
            "Un courriel le lundi matin (heure de l'Est) avec les cinq vidéos qui coûtent le plus de minutes manquantes. Rien n'est envoyé si ton organisation n'a aucun écart.",
            "An email on Monday morning (Eastern time) with the five videos costing the most missing minutes. Nothing is sent if your organisation has no gap.",
          )}
        </span>
      </span>
    </label>
  );
};

export default GapsWeeklyEmailToggle;
